/**
 * Origem Flow: cor de identidade de cada tabela, usada para marcar a origem
 * das tarefas nos calendários (agregado de "Todas as tarefas" e views de
 * calendário das tabelas). Automática e determinística: a mesma tabela tem
 * sempre a mesma cor, derivada do id sobre uma paleta fixa de tons vivos
 * que funcionam nos dois temas.
 */
const TABLE_COLOR_PALETTE = [
  '#4f9cf9', // azul
  '#3fbf7f', // verde
  '#9f6ef2', // roxo
  '#f2a33c', // laranja
  '#2fc1d3', // ciano
  '#e05fb0', // rosa
  '#f2778c', // coral
  '#8a7cf2', // violeta
  '#b8a53a', // oliva
  '#d98d5f', // terracota
]

export function tableColorHex(tableId) {
  const id = parseInt(tableId, 10)
  if (isNaN(id)) {
    return TABLE_COLOR_PALETTE[0]
  }
  return TABLE_COLOR_PALETTE[id % TABLE_COLOR_PALETTE.length]
}
